import { trackEvent } from '@patrianna/analytics'
import cx from 'classnames'
import Link from 'next/link'

import ROUTES from 'config/routes.json'

import LogoBrand from './LogoBrand'
import type { svgPlaceType } from './types'

type Props = {
  isDarkMode?: boolean
  restrictClickEvent?: boolean
} & svgPlaceType

export default function LogoLinkClient(props: Props) {
  const { restrictClickEvent = false } = props

  return (
    <Link
      href={ROUTES.HOME}
      passHref
      prefetch={false}
      data-test-='logo-link'
      aria-label='logo'
      onClick={() => trackEvent('top_menu_logo_click')}
      className={cx({
        'pointer-events-none': restrictClickEvent,
      })}
    >
      <LogoBrand {...props} />
    </Link>
  )
}
